import { initEmitIframeResize } from "@solvari/common-fe/helpers";

import "@/shared/tailwind.css";
import "@solvari/components/blade/review/review-widget/reviewWidget.css";

initEmitIframeResize();
